import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Welcome.css";
import { toTitleCase } from "../../Utils/helper";

const Welcome = () => {
  return (
    <div className="welcome-app">
      {/* Modern Header */}
      {/* <header className="welcome-navbar">
        <div className="container d-flex justify-content-center">
          <nav className="navbar">
            <div className="navbar-brand">
              <span className="logo-icon">◯</span>
              <span className="logo-text">obhiasb</span>
            </div>
          </nav>
        </div>
      </header> */}

      {/* Hero Section */}
      <section className="welcome-hero">
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">
              Streamline Your <span className="text-accent">Account Management</span>
            </h1>
            <p className="hero-subtitle">
              {toTitleCase('Powerful tools for administrators and users in one integrated platform')}
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <main className="welcome-content">
        <div className="container">
          <div className="content-card">
            <h2 className="section-title">Getting Started</h2>
            <p className="section-description">
              {toTitleCase('Follow this guide to maximize your experience with our platform')}
            </p>

            <div className="steps-container">
              {[
                "Request account creation from your administrator",
                "Navigate using the sidebar menu for all features",
                "Process transactions through the dedicated module",
                "Access banking functions in the Finance section",
                "Manage web properties via Website options",
                "Create user roles in the Administration panel",
                "Review all profiles in the Directory",
                "Analyze data with our reporting dashboard"
              ].map((step, index) => (
                <div key={index} className="step-item">
                  <div className="step-number">{index + 1}</div>
                  <div className="step-text">{toTitleCase(step)}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="welcome-footer">
        <div className="container">
          <div className="footer-content">
            <p className="copyright">
              © {new Date().getFullYear()} Hobhiasb Platform. All Rights Reserved.
            </p>
            <div className="footer-links">
              <a href="#">Terms</a>
              <a href="#">Privacy</a>
              <a href="#">Support</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Welcome;